// Jordan 27.10 : « Pertes stock (net) » = pertes + récupérations + écarts
// d'inventaire (règle du 24.07). Un net NÉGATIF (du stock retrouvé à
// l'inventaire, ex. septembre 2026 : −343.22) s'affiche en « Gain
// d'inventaire », valeur absolue, en vert. Calcul serveur inchangé.
export const pertesStockKpi = (net) => {
	const v = Number(net) || 0
	return v < 0
		? { label: "Gain d'inventaire", valeur: Math.abs(v), gain: true }
		: { label: "Pertes stock (net)", valeur: v, gain: false }
}

// Graphique mensuel : barre verte pour un mois en gain, rouge en perte.
export const couleurMois = (valeur, { gain, perte }) =>
	(Number(valeur) || 0) < 0 ? gain : perte

// Infobulle : « Gain d'inventaire » + valeur absolue pour un mois négatif.
export const libelleMois = (valeur) =>
	(Number(valeur) || 0) < 0 ? "Gain d'inventaire" : "Pertes (net)"
